import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBagAdd2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShoppingBagAdd2"><Path d="M12.5 21.5H4L6 7.5H18L18.8571 13.5M15.5 7.5V6C15.5 4.067 13.933 2.5 12 2.5C10.067 2.5 8.5 4.067 8.5 6V7.5M18.5 16.5V19.5M18.5 19.5V22.5M18.5 19.5H15.5M18.5 19.5H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShoppingBagAdd2;
